var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"form-item-desc"},[_c('div',{staticClass:"form-item-desc__form-item"},[_vm._t("default")],2),_c('span',{staticClass:"form-item-desc__desc"},[_vm._t("desc")],2)])}
var staticRenderFns = []

export { render, staticRenderFns }